import React, { useState, useEffect, useRef } from 'react';

export default function TestimonialsSection() {
  const [isPaused, setIsPaused] = useState(false);
  const scrollContainerRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      text: "I'll know it when i see it the hair is just too polarising, for we need more images of groups of people having non-specific types of fun make the font bigger. The website doesn't have the theme i was.",
      name: "Martin Jhon",
      role: "CEO, AIGENCE",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
      rating: 5,
    },
    {
      id: 2,
      text: "Start on it today and we will talk about what i want next time can you lower the price for the website? make it high quality and please use html can you make the font a bit bigger and change it to.",
      name: "Jane Cooper",
      role: "CEO, AIGENCE",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
      rating: 5,
    },
    {
      id: 3,
      text: "The team delivered exceptional results beyond our expectations. Their attention to detail and creative approach transformed our vision into reality. Highly recommend their services!",
      name: "Robert Fox",
      role: "CTO, TechVision",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
      rating: 5,
    },
    {
      id: 4,
      text: "Outstanding work! They understood our requirements perfectly and delivered a solution that exceeded all our benchmarks. The collaboration was smooth and professional throughout.",
      name: "Sarah Williams",
      role: "Director, InnovateLabs",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
      rating: 5,
    },
    {
      id: 5,
      text: "Incredible experience working with this agency. Their innovative solutions and dedication to excellence made our project a huge success. Will definitely work with them again!",
      name: "Michael Chen",
      role: "Founder, StartupHub",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
      rating: 5,
    },
    {
      id: 6,
      text: "Professional, creative, and reliable. The team went above and beyond to ensure our project was delivered on time with exceptional quality. Truly a pleasure to work with!",
      name: "Emily Davis",
      role: "Marketing Head, BrandCo",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop",
      rating: 5,
    },
  ];

  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let animationId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5; // Adjust speed here

    const scroll = () => {
      if (!isPaused) {
        scrollPosition += scrollSpeed;
        
        // Reset scroll position when we've scrolled through one set of testimonials
        if (scrollPosition >= scrollContainer.scrollWidth / 2) {
          scrollPosition = 0;
        }
        
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [isPaused]);

  return (
    <div className="bg-gradient-to-br from-gray-50 to-purple-50 flex items-center justify-center py-10 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12">
      <div className="w-full">
        {/* Header */}
        <div className="text-center mb-8 animate-fadeInDown">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            What They Are
            <br />
            Talking About Agency
          </h2>
        </div>

        {/* Scrolling Container */}
        <div className="relative">
          {/* Cards Container */}
          <div
            ref={scrollContainerRef}
            className="flex gap-6 overflow-x-hidden py-8"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            style={{ scrollBehavior: 'auto' }}
          >
            {duplicatedTestimonials.map((testimonial, index) => (
              <div
                key={`${testimonial.id}-${index}`}
                className="flex-shrink-0 w-[500px] group"
              >
                <div className="relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 h-full">
                  {/* Quote Icon */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                    </svg>
                  </div>

                  {/* Testimonial Text */}
                  <div className="mb-6">
                    <p className="text-gray-500 italic leading-relaxed text-lg">
                      {testimonial.text}
                    </p>
                  </div>

                  {/* Star Rating */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-6 h-6 text-fuchsia-500 transform group-hover:scale-110 transition-transform duration-300"
                        style={{ transitionDelay: `${i * 50}ms` }}
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    ))}
                  </div>

                  {/* Author Info Bar */}
                  <div className="relative">
                    <div className="bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 rounded-2xl p-6 flex items-center justify-between overflow-hidden group-hover:shadow-lg transition-shadow duration-300">
                      {/* Animated background effect */}
                      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-orange-400 to-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                      
                      {/* Author Details */}
                      <div className="relative z-10">
                        <h4 className="text-white font-bold text-xl mb-1">
                          {testimonial.name}
                        </h4>
                        <p className="text-purple-200 text-sm font-medium tracking-wide">
                          {testimonial.role}
                        </p>
                      </div>

                      {/* Author Image */}
                      <div className="relative z-10 transform group-hover:scale-110 transition-transform duration-300">
                        <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-xl">
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        {/* Glow effect behind image */}
                        <div className="absolute inset-0 rounded-full bg-white opacity-30 blur-md animate-pulse"></div>
                      </div>
                    </div>

                    {/* Decorative corner element */}
                    <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-br from-purple-400 to-fuchsia-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-ping"></div>
                  </div>

                  {/* Top right decorative element */}
                  <div className="absolute top-4 right-4 w-3 h-3 bg-purple-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-bounce"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .animate-fadeInDown {
          animation: fadeInDown 1s ease-out;
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        /* Hide scrollbar */
        div::-webkit-scrollbar {
          display: none;
        }
        
        div {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}